<template>
  <div class="home">
    <BeerList/>
  </div>
</template>

<script>
// @ is an alias to /src
import BeerList from '@/components/BeerList.vue'

export default {
  name: 'Home',
  components: {
    BeerList
  }
}
</script>
